import { useGetTourQuery } from '@carboncopyco/data';
import { ShowOutlineIcon } from '@carboncopyco/icons';
import type { TopAsset } from '@carboncopyco/types';
import { ColorHex, TooltipBubble } from '@carboncopyco/ui';
import classNames from 'classnames';
import { useDashboardProps } from '../../DashboardContext';

export const PreviewTourButton = ({ asset }: { asset: TopAsset }) => {
  const { goToTourPreview, organizationId } = useDashboardProps();
  const { assetId, workspaceId } = asset;
  const disabled = asset.status === 'deleted' || asset.status === 'inactive';
  const { error } = useGetTourQuery({
    id: Number(assetId),
    organizationId,
    workspaceId,
  });

  const onClick = (event) => {
    if (error) {
      return undefined;
    }
    event.stopPropagation();
    return goToTourPreview(Number(assetId), workspaceId);
  };

  return (
    <div
      onClick={onClick}
      className={classNames({ 'cursor-pointer': onClick })}
    >
      <TooltipBubble
        title="Preview"
        placement="top"
        disabled={disabled}
      >
        <ShowOutlineIcon
          size={16}
          color={disabled ? ColorHex.natural200 : ColorHex.natural600}
        />
      </TooltipBubble>
    </div>
  );
};
